import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import {
  galleryService,
  type GalleryListOptions,
} from '../../../services/GalleryService';
import { galleryQueryKeys } from '../galleryQueryKeys';

type UseGalleryImagesQueryOptions = {
  listOptions: GalleryListOptions;
  enabled?: boolean;
};

export function useGalleryImagesQuery({
  listOptions,
  enabled = true,
}: UseGalleryImagesQueryOptions) {
  const { user } = useAuth();
  const isEnabled = enabled && Boolean(user);

  return useQuery({
    queryKey: galleryQueryKeys.images(listOptions),
    enabled: isEnabled,
    queryFn: () => galleryService.listImages(listOptions),
  });
}
